import React, { useEffect, useRef, useState } from "react";
import { useLanguage } from "../lib/language";

const useReveal = () => {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (!ref.current || shown) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setShown(true);
            obs.disconnect();
          }
        });
      },
      { threshold: 0.15 }
    );
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, [shown]);
  return [ref, shown];
};

export const Philosophy = () => {
  const { t } = useLanguage();
  const [ref, shown] = useReveal();

  return (
    <section
      ref={ref}
      data-testid="philosophy-section"
      className="bg-resilie-bg px-6 md:px-12 py-28 md:py-40"
    >
      <div className="max-w-3xl mx-auto text-center">
        <p
          data-testid="philosophy-kicker"
          className={`font-sans text-[10px] md:text-[11px] tracking-[0.5em] uppercase text-resilie-muted ${
            shown ? "fade-up" : "opacity-0"
          }`}
        >
          — {t.philosophy.kicker} —
        </p>
        <blockquote
          data-testid="philosophy-quote"
          className={`mt-10 md:mt-14 font-serif font-light text-resilie-ink leading-[1.25] tracking-tight
                      text-[28px] sm:text-[34px] md:text-[44px] lg:text-[52px] ${
                        shown ? "fade-up delay-200" : "opacity-0"
                      }`}
        >
          {t.philosophy.quote}
        </blockquote>
      </div>
    </section>
  );
};

export default Philosophy;
